import { ManageAccounts } from "@mui/icons-material";

export const RoleIcon = ManageAccounts;
